import styled from 'styled-components';

import { getColor, mq, getSpace } from '@stylesheets/tools';

const StyledPopover = styled.div`
  position: relative;

  .popover__close {
    width: 31px;
    height: 31px;
    background: ${getColor('black')};
    color: ${getColor('white')};
    border-radius: 50%;
    flex-shrink: 0;
    align-self: flex-start;

    svg {
      width: 13px;
      height: 13px;
    }
  }

  [role='dialog'] {
    z-index: 99;
  }

  .popover__header,
  .popover__content {
    color: ${getColor('black')};
  }

  .popover__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .popover__panel {
    border: 2px solid ${getColor('darkGray')};
    background-color: ${getColor('white')};
    box-shadow: 0 2px 4px rgba(0, 10, 20, 0.1);
    border-radius: 10px;
    box-sizing: border-box;
    width: calc(100vw - 30px);
    max-width: calc(100vw - 10px);

    ${mq('m')} {
      width: calc(var(--actionsWidth) - 50px);
    }
  }

  .popover__wrapper {
    padding: ${getSpace('xs')} ${getSpace('xxs')} 25px;
    max-height: calc(100vh - 200px);
    overflow-y: auto;

    ${mq('m')} {
      padding: ${getSpace('m')} ${getSpace('s')};
    }
  }
`;

export default StyledPopover;
